import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { Observable } from 'rxjs';
import {
  GetClauseDto,
  ClauseDto,
  BatchUpdateClauseDto,
  CreateClauseDto,
  UpdateClauseDto,
} from '../models/clauses.model';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ClausesApiService extends ApiService {
  getClauses$(): Observable<GetClauseDto[]> {
    return this.get('/clauses');
  }

  createClause$(clause: CreateClauseDto): Observable<GetClauseDto> {
    return this.put('/clauses', clause);
  }

  updateClause$(clause: UpdateClauseDto, uniqueId: string): Observable<GetClauseDto> {
    return this.post(`/clauses/${uniqueId}`, clause);
  }

  getClauseById$(uniqueId: string): Observable<GetClauseDto> {
    return this.get(`/clauses/${uniqueId}`);
  }

  deleteClause$(uniqueId: string): Observable<any> {
    return this.delete(`/clauses/${uniqueId}`);
  }

  batchUpdateClauses$(clauses: BatchUpdateClauseDto[]): Observable<GetClauseDto[]> {
    return this.post(`/clauses/batch-update`, clauses);
  }

  batchDeleteClauses$(uniqueIds: string[]): Observable<any> {
    return this.post(`/clauses/batch-delete`, uniqueIds);
  }
}

export const apiClausesProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiClauses.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiClauses.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiClauses.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiClauses.scopes.write],
  },
];
